export function getConfig() {
  return window.__config || {};
}
